import React, { useState } from "react";
import { Form, Button, Alert, Spinner } from "react-bootstrap";
import { usePasswordRecovery } from "hooks/accountManagement/useAccountRecovery";
import { useNavigate } from "react-router-dom";

const PasswordReset = () => {
  const navigate = useNavigate();
  const { loading, error, startRecovery } = usePasswordRecovery();

  const [usernameOrEmail, setUsernameOrEmail] = useState("");
  const [lastName, setLastName] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [validationError, setValidationError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setValidationError("");
    if (!usernameOrEmail.trim()) return setValidationError("Please enter your username or email");

    try {
      const data = await startRecovery({
        usernameOrEmail: usernameOrEmail.trim(),
        lastName: lastName.trim() || undefined,
        dateOfBirth: dateOfBirth || undefined,
      });
      navigate("/authentication/split/forgot-password/verify", {
        state: { recoveryId: data.recoveryId, questions: data.questions },
      });
    } catch {}
  };

  return (
    <div className="">

      <div>

        {/* Title - zero top margin */}
        <h4 className="text-center fw-bold mb-2">Forgot Password?</h4>
        <p className="text-center text-muted small mb-3">Enter your details below</p>

        {/* Error */}
        {(validationError || error) && (
          <Alert variant="danger" className="small py-1 mb-2">
            {validationError || error}
          </Alert>
        )}

        <Form onSubmit={handleSubmit}>

          {/* Username/Email */}
          <Form.Group className="mb-3">
            <Form.Label className="small fw-medium mb-0">
              Username or Email <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="email or username"
              value={usernameOrEmail}
              onChange={(e) => setUsernameOrEmail(e.target.value)}
              required
              disabled={loading}
              autoFocus
              style={{ height: "40px" }}
            />
          </Form.Group>

          {/* Optional fields - ultra tight */}
          <div className="mb-2">
            <p className="text-success text-center fw-semibold small mb-1">
              Fill one of these to verify identity
            </p>

            <Form.Group className="mb-1 mt-3">
              <Form.Label className="small text-muted mb-0">Last Name (optional)</Form.Label>
              <Form.Control
                type="text"
                placeholder="Last name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                disabled={loading}
                style={{ height: "38px" }}
              />
            </Form.Group>

            <div className="text-center text-muted small my-0">— or —</div>

            <Form.Group className="mt-1 mb-3">
              <Form.Label className="small text-muted mb-0">Date of Birth (optional)</Form.Label>
              <Form.Control
                type="date"
                value={dateOfBirth}
                onChange={(e) => setDateOfBirth(e.target.value)}
                disabled={loading}
                style={{ height: "38px" }}
              />
            </Form.Group>
          </div>

          {/* Button */}
          <Button
            variant="success"
            type="submit"
            className="w-100 fw-semibold"
            disabled={loading || !usernameOrEmail.trim()}
            style={{
              backgroundColor: "#28a745",
              border: "none",
              height: "42px",
            }}
          >
            {loading ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Sending...
              </>
            ) : (
              "Continue"
            )}
          </Button>

          {/* Back link - zero bottom space */}
          <div className="text-center mt-3">
            <Button
              variant="link"
              onClick={() => navigate("/authentication/simple/login")}
              disabled={loading}
              className="text-muted small p-0"
            >
              Back to Login
            </Button>
          </div>

        </Form>
      </div>
    </div>
  );
};

export default PasswordReset;